import ErrorBoundary from '../ErrorBoundary';import {network} from '../utils/network';import React, { useState, useEffect } from 'react';import {tkn} from '../utils/tkn';import { useWallet } from '@solana/wallet-adapter-react';import {cluster} from '../utils/cluster';import { getFirestore, doc, getDoc } from 'firebase/firestore';import {epbase} from '../utils/epbase';import { initializeApp, getApps } from 'firebase/app';import {provider} from '../utils/provider';import {stage1} from '../utils/stages';import { dbConfig } from '../hooks/dbConfig';import { useBatchdata } from '../hooks';
import fetch from 'cross-fetch';


// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -


const RefStats: React.FC<{ onClose: () => void }> = ({ onClose }) => {
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    const vestedMonths = 16;    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    const { currentBatchData } = useBatchdata();
    const { currPrice } = currentBatchData;
    const { publicKey } = useWallet();
    const [userAddress, setUserAddress] = useState<string>('');
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    const [purchasedTokens, setPurchasedTokens] = useState<number>(0);
    const [referralRewards, setReferralRewards] = useState<number>(0);
    const [affiliateRewards, setAffiliateRewards] = useState<number>(0);
    const [reAffiliateRewards, setReAffiliateRewards] = useState<number>(0);
    const [usdSpent, setUsdSpent] = useState<number>(0);
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    const [totalTokens, setTotalTokens] = useState<number>(0);
    const [dcaVal, setDcaVal] = useState<number>(0);
    const [currentPrice, setCurrentPrice] = useState<number>(0);
    const [roiVal, setRoiVal] = useState<number>(0);
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    const [referrerPercentage, setReferrerPercentage] = useState <number>(15);
    const [affiliatePercentage, setAffiliatePercentage] = useState <number>(10);
    const [reAffiliatePercentage, setReAffiliatePercentage] = useState <number>(5);
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    const [refLink, setRefLink] = useState<string>('');
    const [formattedPublicKey, setFormattedPublicKey] = useState<string>('');
    const [copiedRefCode, setCopiedRefCode] = useState<boolean>(false);
    const [copiedRefLink, setCopiedRefLink] = useState<boolean>(false);
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    const [bemePrice, setBemePrice] = useState<number>(0);
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -

    useEffect(() => {
        // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
        try{
            // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
            const baseUrl = window.location.origin;
            if (publicKey) {
                const publicKeyString = publicKey.toString();
                const first = publicKeyString.substring(0, 8);
                const last = publicKeyString.slice(-8);
                setFormattedPublicKey(`${first}...${last}`);
                setRefLink(`${baseUrl}/?ref=${publicKeyString}`);
            // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
            } else {
                setFormattedPublicKey('');
                setRefLink('');
            }
        // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
        } catch(e){}
    
        try{
            // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
            if (publicKey) {
                try{
                    const fetchUserStats = async () => {  
                        const basemint = "BEMEeJ8sSyQXswNiZ98M8ppyJGDE4g5UumqgZkANNVbb"; // bemeow
                        const url = `https://api-v3.raydium.io/mint/price?mints=${basemint}`;
                        try{
                            const quoteResponse = await fetch(url).then(response => response.json());
                            if (quoteResponse?.success && quoteResponse?.data?.[basemint]) {
                                setBemePrice(quoteResponse.data[basemint]);
                            } else {
                                setBemePrice(0);
                            }
                        }catch(e){
                            setBemePrice(0);
                        } 
                    }  
                    fetchUserStats();
                }catch(e){
                    setBemePrice(0);
                }
    
                // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                } else {
                    setBemePrice(0);
                }
            
        // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
        } catch(e){}
    
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    }, [publicKey]);



    useEffect(() => {
        try{
            // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
            if (!publicKey) return;
            if(publicKey){
                const _userAddress = publicKey.toBase58();
                setUserAddress(_userAddress);  
            }
            // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
            if(bemePrice && typeof Number(bemePrice) == "number"){
                const _currPrice = bemePrice? bemePrice : 0;
                setCurrentPrice(_currPrice);
            }
            // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
            const fetchUserStats = async () => {  
                try{
                    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                    const dbConfigs = await dbConfig();
                    let app;
                    if (!getApps().length) { 
                        app = initializeApp(dbConfigs);
                    } else {
                        app = getApps()[0];
                    }
                    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                    const db = getFirestore(app);
                    const _presaleGlobals = doc(db, "bemeowPresale", "db_presaleGlobals");
                    const presaleGlobalsSnap = await getDoc(_presaleGlobals);
                    let _referrerPercentage = 15; let _affiliatePercentage = 10; let _reAffiliatePercentage = 5;
                    if (presaleGlobalsSnap.exists()) {
                        // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                        try{
                            const presaleGlobals = presaleGlobalsSnap.data();
                            if(presaleGlobals){
                                _referrerPercentage     = Number(presaleGlobals?.referral?.referrerPercentage)      || 15;
                                _affiliatePercentage    = Number(presaleGlobals?.referral?.affiliatePercentage)     || 10;
                                _reAffiliatePercentage  = Number(presaleGlobals?.referral?.reAffiliatePercentage)   || 5;
                                setReferrerPercentage(_referrerPercentage); 
                                setAffiliatePercentage(_affiliatePercentage); 
                                setReAffiliatePercentage(_reAffiliatePercentage);
                            }
                        } catch(e){}
                    }
                    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -   
                    if(userAddress){
                        try{
                            const response = await fetch(`${network[1]}${provider[2]}.${epbase[2]}/v0/b/${epbase[1]}.${cluster[1]}/o/presale%2Fdb_userStats.json?alt=media&token=${tkn[1]}`);
                            if (response.ok) {
                                // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                                const allUserStats = await response.json();
                                if (userAddress in allUserStats) {
                                    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                                    const userStats = allUserStats[userAddress];
                                    if (userStats && userStats.length === 5) {
                                        // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                                        try{
                                            const purchased = Math.trunc(Number(userStats[0]))      || 0; setPurchasedTokens(purchased);
                                            const referral = Math.trunc(Number(userStats[1]))       || 0; setReferralRewards(referral);
                                            const affiliate = Math.trunc(Number(userStats[2]))      || 0; setAffiliateRewards(affiliate);
                                            const reAffiliate = Math.trunc(Number(userStats[3]))    || 0; setReAffiliateRewards(reAffiliate);
                                            const spent = Math.trunc(Number(userStats[4]))          || 0; setUsdSpent(spent);
                                            let total = 0;
                                            // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                                            let statArrayValCnt = 0;
                                            for(const num of userStats){
                                                statArrayValCnt++;
                                                if(typeof(num) === 'number' && statArrayValCnt < 5){
                                                    total += num;
                                                }
                                            }
                                            // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                                            setTotalTokens(total? total : 0);
                                            if (total && total > 0 && spent) {
                                                try{
                                                    const _dcaVal = (spent / total) || 0;
                                                    setDcaVal(_dcaVal);
                                                    if (_dcaVal && _dcaVal > 0 && bemePrice && bemePrice > 0) {
                                                        const _roiVal = ((bemePrice / _dcaVal) - 1) || 0;
                                                        setRoiVal(_roiVal);
                                                    } 
                                                } catch(e){}
                                            } 
                                        // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                                        } catch(e){}
                                    }
                                }                 
                            }
                        // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                        } catch(e){}
                    }
                // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                } catch(e){}
            };
        // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -    
        const interval = setInterval(fetchUserStats, 1000);
        fetchUserStats();
        return () => clearInterval(interval);
    // - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
    } catch(e){}
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
}, [userAddress, bemePrice]);
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - 

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
const handleCopyLink = () => {
    try{
        if (publicKey) {
            navigator.clipboard.writeText(refLink).then(() => {
                setCopiedRefLink(true);
                setTimeout(() => setCopiedRefLink(false), 2000);
            });
        }
    } catch(e){}
};
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
const handleCopyRefCode = () => {
    try{
        if (publicKey) {
            navigator.clipboard.writeText(publicKey.toString()).then(() => {
                setCopiedRefCode(true);
                setTimeout(() => setCopiedRefCode(false), 2000);
            });
        }
    } catch(e){}
};
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
const toReadbl = (value: any): string => {
    try{
        if (!value || typeof(value) !== 'number' || isNaN(value)) {return 'n/a';}
        value = Math.trunc(value);
        return value.toLocaleString('en-US');
    } catch(e){
        return "";
    }
};
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
try{
    return (
        <ErrorBoundary>
            <div className="stats-wrapper">
                <div className="moz-top-space" style={{ height: '0px', maxHeight:'0px', visibility: 'hidden' }}></div>
                <div className="stats-close-button" onClick={onClose}>
                    <span className="stats-close-button-span">X</span>
                </div>
                <div className="details-header">
                    <h2 className="stats-details-title" style={{ marginLeft: '-2.5px' }}>Presale</h2>
                </div>
                
                <div className="stats-content">
                    <table className="stats-details-table" style={{ fontSize: '12px' }}>
                        <tbody>
                        <tr>
                            <th>
                            <hr></hr>
                            </th>
                        </tr>



                        {/*}
                        <tr>
                            <th className="ico-details-col-1">
                                <span className="ref-code-caption" style={{ marginLeft: '1px' }}>Referral-Code</span>
                                <button
                                    onClick={handleCopyRefCode} 
                                    className={`copy-button ${!publicKey ? 'disabled' : ''}`} 
                                    disabled={!publicKey}
                                >
                                    Copy
                                </button>
                                {copiedRefCode && <span className="copied-message">Copied!</span>}
                            </th>
                        </tr>
                        <tr>
                            <th className="ico-details-col-1">
                                <span className="ref-code">
                                {publicKey ? (
                                    <span className="ref-code-active">{userAddress}</span>
                                ) : (
                                    <span className="ref-code-inactive">Connect your wallet first</span>
                                )}
                                </span>
                            </th>
                        </tr>
                        <tr>
                            <th className="ico-details-col-1">
                                <span className="ref-link-caption" style={{ marginLeft: '1px' }}>Referral-Link </span>
                                <button 
                                    onClick={handleCopyLink} 
                                    className={`copy-button ${!publicKey ? 'disabled' : ''}`} 
                                    disabled={!publicKey}
                                    style={{ marginLeft: '15px' }}
                                >
                                    Copy
                                </button>
                                {copiedRefLink && <span className="copied-message">Copied!</span>}
                            </th>
                        </tr>
                        <tr>
                            <th className="ico-details-col-1">
                            <div className="ref-link-wrapper">
                                {publicKey ? (
                                    <a 
                                        href={refLink} 
                                        target="_blank" 
                                        rel="noopener noreferrer" 
                                        className="ref-link"
                                    >
                                        <span className="ref-link-active">{`${window.location.origin}/?ref=${formattedPublicKey}`}</span>
                                        
                                    </a>
                                ) : (
                                    <span className="ref-link-inactive">Connect your wallet first</span>
                                )}
                            </div>
                            </th>
                        </tr>

                        <tr>
                            <th>
                            <hr></hr>
                            </th>
                        </tr>
                        */}



                        {/*}
                        <tr>
                            <th className="stats-section-title"><span>Referral</span></th>
                        </tr>


                        <tr className="stats-list-row">
                        <th className="stats-short-col-1">
                            <span style={{fontWeight: "300"}}>Buyers</span>
                        </th>
                            <th className="stats-short-col-2">
                            <span style={{fontWeight: "300"}}>Tier0 (referred)</span>
                        </th>
                            <th className="stats-short-col-3">
                                
                                <span style={{fontWeight: "300"}}>+{(referrerPercentage? referrerPercentage : 15).toFixed(1)}%</span>
                            </th>
                        </tr>


                        <tr className="stats-list-row">
                        <th className="stats-short-col-1">
                            <span style={{fontWeight: "300"}}>Affliates</span>
                        </th>
                            <th className="stats-short-col-2">
                                <span style={{fontWeight: "300"}}>Tier1 (direct) </span>
                            </th>
                            <th className="stats-short-col-3">
                                <span style={{fontWeight: "300"}}>+{(affiliatePercentage? affiliatePercentage : 10).toFixed(1)}%</span>
                            </th>
                        </tr>


                        <tr className="stats-list-row">
                        <th className="stats-short-col-1">
                        <span style={{fontWeight: "300"}}>Re-Affiliates</span>
                            </th>
                            <th className="stats-short-col-2">
                            <span style={{fontWeight: "300"}}>Tier2 (indirect) </span>
                            </th>
                            <th className="stats-short-col-3">
                                <span style={{fontWeight: "300"}}>+{(reAffiliatePercentage? reAffiliatePercentage : 5).toFixed(1)}%</span>
                            </th>
                        </tr>

                        <tr>
                            <th>
                                <hr></hr>
                            </th>
                        </tr>

                        */}





                        <tr>
                            <th className="stats-section-title"><span>Allocation</span></th>
                        </tr>


                            <tr className="stats-list-row">
                                <th className="stats-short-col-1">
                                    <span style={{fontWeight: "300"}}>
                                        {stage1.includes(userAddress) ? "Total Tokens ¹" : "Total Tokens"}
                                    </span>
                                </th>
                            
                                <th className="stats-short-col-2">
                                
                                    <span style={{fontWeight: "300"}}>{toReadbl(totalTokens)}</span>

                                </th>
                                <th className="stats-short-col-3">
                                <span style={{fontWeight: "300"}}>{totalTokens && typeof(totalTokens) === 'number' ? (100).toFixed(1) + '%' : 'n/a'}</span>
                                </th>
                                
                            </tr>
                           

                            <tr className="stats-list-row">
                                <th className="stats-short-col-1">
                                <span style={{fontWeight: "300"}}>Bought</span>
                                </th>
                                <th className="stats-short-col-2">
                                <span style={{fontWeight: "300"}}>{toReadbl(purchasedTokens)}</span>
                                </th>
                                <th className="stats-short-col-3">
                                <span style={{fontWeight: "300"}}>{totalTokens && typeof(totalTokens) === 'number' && purchasedTokens && typeof(purchasedTokens) === 'number' ? ((Number(purchasedTokens) / Number(totalTokens)) * 100).toFixed(1) + '%' : 'n/a'}</span>
                                </th>
                            </tr>


                            <tr className="stats-list-row">
                                <th className="stats-short-col-1">
                                <span style={{fontWeight: "300"}}>Referral</span>
                                </th>
                                <th className="stats-short-col-2">
                                <span style={{fontWeight: "300"}}>{toReadbl(referralRewards)}</span>
                                </th>
                                <th className="stats-short-col-3">
                                <span style={{fontWeight: "300"}}>{totalTokens && typeof(totalTokens) === 'number' && referralRewards && typeof(referralRewards) === 'number' ? ((Number(referralRewards) / Number(totalTokens)) * 100).toFixed(1) + '%' : 'n/a'}</span>
                                </th>
                            </tr>

                            <tr className="stats-list-row">
                                <th className="stats-short-col-1">
                                <span style={{fontWeight: "300"}}>Affiliate</span>
                                </th>
                                <th className="stats-short-col-2">
                                <span style={{fontWeight: "300"}}>{toReadbl(affiliateRewards)}</span>
                                </th>
                                <th className="stats-short-col-3">
                                <span style={{fontWeight: "300"}}>{totalTokens && typeof(totalTokens) === 'number' && affiliateRewards && typeof(affiliateRewards) === 'number' ? ((Number(affiliateRewards) / Number(totalTokens)) * 100).toFixed(1) + '%' : 'n/a'}</span>
                                </th>
                            </tr>


                            <tr className="stats-list-row">
                                <th className="stats-short-col-1">
                                <span style={{fontWeight: "300"}}>Re-Affiliate</span>
                                </th>
                                <th className="stats-short-col-2">
                                <span style={{fontWeight: "300"}}>{toReadbl(reAffiliateRewards)}</span>
                                </th>
                                <th className="stats-short-col-3">
                                <span style={{fontWeight: "300"}}>{totalTokens && typeof(totalTokens) === 'number' && reAffiliateRewards && typeof(reAffiliateRewards) === 'number'  ? ((Number(reAffiliateRewards) / Number(totalTokens)) * 100).toFixed(1) + '%' : 'n/a'}</span>
                                </th>
                            </tr>


                            <tr>
                                <th>
                                    <hr></hr>
                                </th>
                            </tr>







<tr>
                            <th className="stats-section-title"><span>Vesting</span></th>
                        </tr>


                            <tr className="stats-list-row">
                                <th className="stats-short-col-1">
                                    <span style={{fontWeight: "300"}}>Released</span>
                                </th>
                            
                                <th className="stats-short-col-2">
                                
                                    <span style={{fontWeight: "300"}}>{toReadbl(  Math.trunc(totalTokens * 0.05 * vestedMonths)  )}</span>

                                </th>
                                <th className="stats-short-col-3">
                                <span style={{fontWeight: "300"}}>{toReadbl(  Math.trunc(5 * vestedMonths)  )}%</span>
                                </th>
                                
                            </tr>
                           

                            <tr className="stats-list-row">
                                <th className="stats-short-col-1">
                                    <span style={{fontWeight: "300"}}>Remaining</span>
                                </th>
                            
                                <th className="stats-short-col-2">
                                
                                    <span style={{fontWeight: "300"}}>{toReadbl(  Math.trunc(totalTokens * 0.05 * ( 20 - vestedMonths ) )  )}</span>

                                </th>
                                <th className="stats-short-col-3">
                                <span style={{fontWeight: "300"}}>{toReadbl(  Math.trunc(5 * ( 20 - vestedMonths ) )  )}%</span>
                                </th>
                                
                            </tr>


                            <tr className="stats-list-row">
                                <th className="stats-short-col-1">
                                <span style={{fontWeight: "300"}}>Next Amount</span>
                                </th>
                                <th className="stats-short-col-2">
                                <span style={{fontWeight: "300"}}>{ toReadbl(totalTokens * 0.05 ) }</span>
                                </th>
                                <th className="stats-short-col-3">
                                <span style={{fontWeight: "300"}}>5%</span>
                                </th>
                            </tr>



                            <tr className="stats-list-row">
                                <th className="stats-short-col-1">
                                <span style={{fontWeight: "300"}}>Next Release</span>
                                </th>
                                <th className="stats-short-col-2">
                                <span style={{fontWeight: "300"}}>{String("11 July")}</span>
                                </th>
                                <th className="stats-short-col-3">
                                <span style={{fontWeight: "300"}}>{String("2026")}</span>
                                </th>
                            </tr>



                            <tr>
                                <th>
                                    <hr></hr>
                                </th>
                            </tr>


















                            
                            <tr>
                                <th className="stats-section-title"><span>Figures</span></th>
                            </tr>

                            <tr className="stats-list-row">
                                <th className="stats-short-col-1">
                                    <span style={{fontWeight: "300"}}>Total Spent</span>
                                </th>
                                <th className="stats-short-col-2">
                                <span style={{fontWeight: "300"}}> </span>
                                </th>
                                <th className="stats-short-col-3">
                                    <span style={{fontWeight: "300", position: 'absolute', right: '0px', justifyContent: 'flex-end', marginTop: '-7px', textAlign: 'right'}}>{usdSpent && typeof(Number(usdSpent)) === 'number' ? '$' + Number(usdSpent).toFixed(2) : 'n/a'}</span>
                                </th>
                            </tr>


                            <tr className="stats-list-row">
                                <th className="stats-short-col-1">
                                    <span style={{fontWeight: "300"}}>Total Value</span>
                                </th>
                                <th className="stats-short-col-2">
                                <span style={{fontWeight: "300"}}> </span>
                                </th>
                                <th className="stats-short-col-3">
                                    <span style={{fontWeight: "300", position: 'absolute', right: '0px', justifyContent: 'flex-end', marginTop: '-7px', textAlign: 'right'}}>
                                        {totalTokens && typeof(totalTokens) === 'number' && currentPrice && !isNaN(Number(bemePrice))? '$' + (Number(totalTokens) * Number(bemePrice)).toFixed(0) : 'n/a'}
                                        
                                    </span>
                                </th>
                            </tr>


                            <tr className="stats-list-row">
                                <th className="stats-short-col-1">
                                    <span style={{fontWeight: "300"}}>DCA Price</span>
                                </th>
                                <th className="stats-short-col-2">
                                <span style={{fontWeight: "300"}}> </span>
                                </th>
                                <th className="stats-short-col-3">
                                <span style={{fontWeight: "300", position: 'absolute', right: '0px', justifyContent: 'flex-end', marginTop: '-7px', textAlign: 'right'}}>{dcaVal && !isNaN(Number(dcaVal)) ? '$' + (Number(dcaVal)).toFixed(5) : 'n/a'}</span>
                                </th>
                            </tr>

                            <tr className="stats-list-row">
                                <th className="stats-short-col-1">
                                    <span style={{fontWeight: "300"}}>Current Price</span>
                                </th>
                                <th className="stats-short-col-2">
                                <span style={{fontWeight: "300"}}> </span>
                                </th>
                                <th className="stats-short-col-3">
                                    <span style={{fontWeight: "300", position: 'absolute', right: '0px', justifyContent: 'flex-end', marginTop: '-7px', textAlign: 'right'}}>{bemePrice && !isNaN(Number(bemePrice)) && bemePrice > 0 ? '$' + (Number(bemePrice)).toFixed(5) : 'n/a'  }</span>
                                </th>
                            </tr>

                            <tr className="stats-list-row">
                                <th className="stats-short-col-1">
                                    <span style={{fontWeight: "300"}}>Current ROI</span>
                                </th>
                                <th className="stats-short-col-2">

                                <span style={{fontWeight: "300"}}>
                                    {roiVal && roiVal && typeof(Number(roiVal)) === 'number'? (roiVal * 100).toFixed(1) + '%' : 'n/a'}
                                </span>
                                
                                </th>
                                <th className="stats-short-col-3">
                                <span style={{fontWeight: "300", position: 'absolute', right: '0px', justifyContent: 'flex-end', marginTop: '-7px', textAlign: 'right'}}>

                                
                                {
                                    roiVal && roiVal && typeof(Number(roiVal)) === 'number' && usdSpent && typeof(Number(usdSpent)) === 'number'? 
                                            '$' + String((Number(roiVal)  * Number(usdSpent)).toFixed(0)) :
                                    totalTokens && typeof(totalTokens) === 'number' && bemePrice && !isNaN(Number(bemePrice)) && usdSpent && typeof(Number(usdSpent)) === 'number'?
                                            '$' + String((((Number(totalTokens) * Number(bemePrice)) - usdSpent )).toFixed(0)) 
                                    : 'n/a'
                                }
                                
                                </span>
                                </th>
                            </tr>



                            <tr>
                                <th>
                                    <hr></hr>
                                </th>
                            </tr>

                        
                        {/*}
                        <tr>
                            <th className="stats-section-title"><span>Referral Rules</span></th>
                        </tr>


                        <tr className="stats-list-row">
                            <th className="stats-short-rules-line">
                                <span style={{fontWeight: "300"}}>» Rewards are top ups (no deduction).</span>
                            </th>  
                            <th className="stats-short-rules-line">
                                <span style={{fontWeight: "300"}}>» Max. indirect referral depth = 1.</span>
                            </th>     
                            <th className="stats-short-rules-line">
                                <span style={{fontWeight: "300"}}>» Only buys over $10 are considered.</span>
                            </th>
                            <th className="stats-short-rules-line">
                                <span style={{fontWeight: "300"}}>» Rewards are vested like sold tokens.</span>
                            </th>
                            <th className="stats-short-rules-line">
                                <span style={{fontWeight: "300"}}>» No self- and cross-referrals.</span>
                            </th>
                            <th className="stats-short-rules-line">
                                <span style={{fontWeight: "300"}}>» Different wallets ok (e.g. campaign tracking)</span>
                            </th>
                        </tr>
                        */}






                        {stage1.includes(userAddress) 

                            ? (

                                <tr className="stats-list-row">
                                <th className="stats-short-rules-line">
                                    <i><span style={{fontWeight: "300"}}>¹ Adjusted to the raised funds & required tokenomics</span></i>
                                </th>  
                                {/*}
                                <th className="stats-short-rules-line">
                                    <i><span style={{fontWeight: "300"}}>* Price feed integration as soon as possible</span></i>
                                </th>  
                                */}
                            </tr>

                            ) : (

                                <tr className="stats-list-row">
                                <th className="stats-short-rules-line">
                                {/*}
                                    <i><span style={{fontWeight: "300"}}>* Price feed integration as soon as possible</span></i>
                                */}
                                </th>  
                            </tr>

                            )

                        }
                        













                        </tbody>
                    </table>
                </div>
            </div>
        </ErrorBoundary>
        );
    }catch(e){}
};
// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
export default RefStats;
